import React, { useState, useEffect } from "react";
import { Typography, Grid, InputBase, Button, } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import useStyles from "./styles";
import { withSnackbar } from "../../../../../../components/Message/Alert";
import { ActionDialog } from "../../../../../../components/ActionDialog/ActionDialog";
import AddNewPhoto from "./components/AddPhoto";
import { PostDataAPI } from "../../../../../../Services/APIService";
import NoRecord from "../../../../../../components/NoRecord/NoRecord";



const CustomCard = ({ organizationId, ...props }) => {
    const classes = useStyles();

    const { showMessage } = props;


    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });
    const [addNewPhoto, setAddNewPhoto] = useState(false);
    const programModal = () => {
        setAddNewPhoto(true);
    };

    const closeAddPhoto = () => {
        setAddNewPhoto(false);
    };



    const handleSuccessClose = (message) => {
        setAddNewPhoto(false);
        loadPhotos();
        showMessage("Success", message, "success", 3000);
    }

    const [dcData, setDcData] = useState([]);


    const loadPhotos = () => {

        let obj = {
            disbursementId: null,
            collectionId: null,
            DonorId: organizationId,
            programId: null,
            Type: "Donor Photo Gallery",
            Category: "Donor",
        }

        PostDataAPI("fdngrantattachments/loadGrid", obj).then((result) => {

            console.log(result);
            if (result.success && result.data != null) {
                setDcData(result.data)
            } else {
                setDcData([]);
            }
        });
    }

    useEffect(() => {
        loadPhotos()
    }, []);
    return (
        <>
            <Grid container className={classes.gridHeader}>
                <Typography variant="h5" className={classes.GridHeading}>
                    Photo Gallery
                </Typography>
                <div className={"HeaderDialog"}>
                    <div className={classes.gridActions}>
                        <Button className={classes.changeBtn} onClick={() => programModal()}>
                            <AddCircleOutlineIcon style={{ marginRight: "6px" }} /> Add Photo
                        </Button>
                    </div>
                </div>
            </Grid>

            <div className={classes.DocMainDiv}>
                {dcData.length > 0 ?
                    <Grid container spacing={2}>
                        {dcData.map((item) => (
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={3}
                                key={item.id}
                                className={classes.CardGrid}
                            >
                                <div className={classes.Card}>
                                    <img src={item.filePath} />
                                </div>
                            </Grid>
                        ))}
                    </Grid>

                    :
                    <Grid container justifyContent="center">
                        <NoRecord Icon={true} iconSize={'300px'} message={'No Photo Found'}></NoRecord>
                    </Grid>
                }

            </div>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
                onClose={() =>
                    setActionDialogState((prevState) => ({
                        ...prevState,
                        showHide: false,
                    }))
                }
            />
            {addNewPhoto ? (
                <AddNewPhoto
                    dialogOpenClose={programModal}
                    handleClose={closeAddPhoto}
                    handleSuccessClose={handleSuccessClose}
                    organizationId={organizationId}
                ></AddNewPhoto>
            ) : (
                ""
            )}
        </>
    );
};

export default withSnackbar(CustomCard);
